import type { SupabaseClient } from '@supabase/supabase-js';
import { config, supabaseConfigured } from '../config.ts';

let client: Promise<SupabaseClient> | null = null;

/** Lazily loaded Supabase Auth client (null when not configured, e.g. local dev). */
export function supabase(): Promise<SupabaseClient> | null {
  if (!supabaseConfigured()) return null;
  client ??= import('@supabase/supabase-js').then(({ createClient }) =>
    createClient(config.supabaseUrl, config.supabaseAnonKey, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true, flowType: 'pkce' },
    }),
  );
  return client;
}
